import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 60,
  },

});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
    className={classes.svg}
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    viewBox="0 0 2521 2200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="nonzero">
      <path
        d="M1316.714 1729.48c0 32.059-26.021 58.063-58.067 58.063-32.075 0-58.054-26.004-58.054-58.062 0-32.063 25.979-58.067 58.054-58.067 32.046 0 58.067 26.004 58.067 58.067z"
        fill="#fff"
      />
      <path
        d="M1316.714 1920.518c0 32.063-26.021 58.063-58.067 58.063-32.075 0-58.054-26-58.054-58.063s25.979-58.062 58.054-58.062c32.046 0 58.067 26 58.067 58.062z"
        fill="#78798a"
      />
      <path
        d="M1316.714 2111.14c0 32.062-26.021 58.066-58.067 58.066-32.075 0-58.054-26.004-58.054-58.067s25.979-58.062 58.054-58.062c32.046 0 58.067 26 58.067 58.062zM1316.714 92.05c0 32.058-26.021 58.063-58.067 58.063-32.075 0-58.054-26.005-58.054-58.063 0-32.062 25.979-58.067 58.054-58.067 32.046 0 58.067 26.005 58.067 58.067z"
        fill="#a5a1b0"
      />
      <path
        d="M1316.714 283.504c0 32.063-26.021 58.067-58.067 58.067-32.075 0-58.054-26.004-58.054-58.067 0-32.058 25.979-58.062 58.054-58.062 32.046 0 58.067 26.004 58.067 58.062z"
        fill="#78798a"
      />
      <path
        d="M1316.714 474.546c0 32.059-26.021 58.063-58.067 58.063-32.075 0-58.054-26.004-58.054-58.063 0-32.062 25.979-58.062 58.054-58.062 32.046 0 58.067 26 58.067 58.062zM1886.118 1043.95c32.063 0 58.063 26.022 58.063 58.068 0 32.075-26 58.054-58.063 58.054s-58.062-25.98-58.062-58.054c0-32.046 26-58.067 58.062-58.067z"
        fill="#fff"
      />
      <path
        d="M2459.24 1043.95c32.058 0 58.062 26.022 58.062 58.068 0 32.075-26.004 58.054-58.063 58.054-32.062 0-58.062-25.98-58.062-58.054 0-32.046 26-58.067 58.062-58.067zM58.063 1043.95c32.058 0 58.062 26.022 58.062 58.068 0 32.075-26.004 58.054-58.062 58.054C26 1160.072 0 1134.092 0 1102.018c0-32.046 26-58.067 58.063-58.067z"
        fill="#dbdae0"
      />
      <path
        d="M248.684 1043.95c32.062 0 58.066 26.022 58.066 58.068 0 32.075-26.004 58.054-58.066 58.054s-58.063-25.98-58.063-58.054c0-32.046 26-58.067 58.063-58.067z"
        fill="#a5a1b0"
      />
      <path
        d="M631.184 1043.95c32.062 0 58.062 26.022 58.062 58.068 0 32.075-26 58.054-58.062 58.054s-58.063-25.98-58.063-58.054c0-32.046 26-58.067 58.063-58.067zM1623.589 1615.73c16.079 27.738 6.608 63.284-21.113 79.355-27.75 16.087-63.266 6.625-79.35-21.113-16.079-27.737-6.641-63.262 21.104-79.35 27.721-16.075 63.28-6.63 79.359 21.108z"
        fill="#fff"
      />
      <path
        d="M1815.01 1945.918c16.083 27.738 6.612 63.284-21.109 79.354-27.75 16.088-63.27 6.625-79.35-21.116-16.079-27.734-6.645-63.263 21.105-79.35 27.72-16.071 63.275-6.625 79.354 21.112z"
        fill="#a5a1b0"
      />
      <path
        d="M1911.039 2111.552c16.08 27.741 6.608 63.287-21.117 79.358-27.746 16.088-63.266 6.62-79.346-21.117-16.079-27.733-6.641-63.262 21.105-79.35 27.72-16.07 63.275-6.625 79.358 21.109zM706.726 34.23c16.083 27.737 6.608 63.287-21.113 79.358-27.746 16.083-63.267 6.62-79.35-21.117-16.08-27.738-6.642-63.263 21.104-79.35 27.725-16.071 63.28-6.63 79.359 21.108z"
        fill="#dbdae0"
      />
      <path
        d="M802.33 199.142c16.083 27.737 6.612 63.283-21.109 79.358-27.75 16.088-63.266 6.621-79.35-21.116-16.079-27.738-6.645-63.263 21.105-79.35 27.72-16.071 63.275-6.626 79.354 21.108z"
        fill="#a5a1b0"
      />
      <path
        d="M898.36 364.78c16.078 27.737 6.607 63.283-21.113 79.354-27.75 16.087-63.267 6.625-79.346-21.117-16.084-27.733-6.646-63.258 21.1-79.346 27.725-16.075 63.275-6.63 79.358 21.108z"
        fill="#78798a"
      />
      <path
        d="M994.176 530.05c16.079 27.738 6.608 63.284-21.113 79.359-27.75 16.087-63.27 6.62-79.35-21.117s-6.641-63.262 21.104-79.35c27.721-16.07 63.28-6.625 79.359 21.108zM1772.372 737.076c27.734-16.084 63.284-6.613 79.354 21.112 16.088 27.746 6.621 63.267-21.112 79.346-27.742 16.083-63.267 6.646-79.354-21.104-16.071-27.721-6.63-63.275 21.112-79.354z"
        fill="#fff"
      />
      <path
        d="M1937.643 641.259c27.738-16.083 63.288-6.608 79.354 21.112 16.088 27.746 6.625 63.267-21.112 79.35-27.738 16.075-63.263 6.642-79.35-21.108-16.071-27.72-6.63-63.275 21.108-79.354z"
        fill="#78798a"
      />
      <path
        d="M2102.556 545.65c27.737-16.079 63.287-6.608 79.358 21.113 16.084 27.75 6.621 63.267-21.116 79.35-27.738 16.08-63.263 6.642-79.35-21.104-16.071-27.721-6.63-63.275 21.108-79.359z"
        fill="#a5a1b0"
      />
      <path
        d="M2268.193 449.625c27.738-16.079 63.284-6.608 79.355 21.113 16.087 27.75 6.625 63.267-21.113 79.346-27.737 16.083-63.262 6.646-79.35-21.104-16.075-27.721-6.629-63.275 21.108-79.355z"
        fill="#dbdae0"
      />
      <path
        d="M521.417 1462.305c27.738-16.079 63.283-6.608 79.354 21.113 16.088 27.75 6.625 63.267-21.112 79.346-27.738 16.083-63.267 6.646-79.35-21.104-16.071-27.721-6.63-63.275 21.108-79.355z"
        fill="#78798a"
      />
      <path
        d="M686.692 1366.489c27.738-16.08 63.284-6.613 79.354 21.112 16.088 27.746 6.625 63.267-21.112 79.346-27.738 16.083-63.267 6.646-79.35-21.104-16.071-27.721-6.63-63.275 21.108-79.354zM1831.156 1365.301c27.77 16.02 37.291 51.558 21.275 79.313-16.025 27.779-51.534 37.291-79.305 21.266-27.77-16.02-37.308-51.52-21.279-79.3 16.013-27.754 51.542-37.3 79.309-21.279z"
        fill="#fff"
      />
      <path
        d="M1996.63 1460.772c27.772 16.025 37.292 51.558 21.276 79.313-16.03 27.783-51.534 37.291-79.304 21.27-27.771-16.025-37.313-51.52-21.28-79.304 16.013-27.754 51.538-37.3 79.309-21.279z"
        fill="#78798a"
      />
      <path
        d="M2161.743 1556.039c27.771 16.02 37.288 51.554 21.275 79.308-16.029 27.783-51.537 37.292-79.308 21.271s-37.308-51.52-21.28-79.304c16.013-27.754 51.543-37.3 79.313-21.275z"
        fill="#a5a1b0"
      />
      <path
        d="M2327.581 1651.718c27.767 16.025 37.288 51.558 21.27 79.313-16.028 27.783-51.537 37.291-79.303 21.27-27.771-16.025-37.309-51.525-21.284-79.304 16.017-27.758 51.542-37.3 79.317-21.279zM247.75 451.73c27.771 16.025 37.292 51.558 21.275 79.312-16.029 27.783-51.537 37.292-79.304 21.27-27.77-16.024-37.308-51.524-21.283-79.303 16.016-27.754 51.541-37.3 79.312-21.28z"
        fill="#dbdae0"
      />
      <path
        d="M578.7 642.676c27.771 16.02 37.288 51.558 21.275 79.312-16.029 27.78-51.537 37.292-79.308 21.267-27.77-16.021-37.308-51.521-21.28-79.3 16.013-27.759 51.543-37.304 79.313-21.28z"
        fill="#78798a"
      />
      <path
        d="M744.171 738.146c27.775 16.025 37.292 51.559 21.275 79.313-16.029 27.783-51.533 37.292-79.304 21.27-27.77-16.024-37.308-51.52-21.279-79.303 16.013-27.759 51.538-37.3 79.308-21.28zM1521.935 529.505c16.025-27.771 51.558-37.288 79.312-21.275 27.783 16.033 37.292 51.537 21.271 79.308s-51.525 37.308-79.304 21.28c-27.754-16.013-37.3-51.543-21.28-79.313z"
        fill="#fff"
      />
      <path
        d="M1712.672 198.925c16.021-27.775 51.554-37.292 79.313-21.275 27.783 16.03 37.291 51.534 21.27 79.304-16.024 27.771-51.524 37.309-79.308 21.28-27.754-16.013-37.3-51.538-21.275-79.309z"
        fill="#a5a1b0"
      />
      <path
        d="M1808.351 33.088c16.025-27.771 51.559-37.288 79.313-21.275 27.783 16.029 37.292 51.537 21.27 79.308-16.024 27.77-51.52 37.308-79.303 21.28-27.755-16.013-37.3-51.543-21.28-79.313zM608.363 2112.914c16.025-27.775 51.558-37.292 79.313-21.275 27.783 16.025 37.295 51.538 21.27 79.304-16.02 27.771-51.52 37.309-79.304 21.28-27.754-16.013-37.3-51.538-21.279-79.309z"
        fill="#dbdae0"
      />
      <path
        d="M703.63 1947.802c16.02-27.771 51.558-37.292 79.312-21.275 27.78 16.029 37.288 51.537 21.267 79.304-16.02 27.77-51.52 37.308-79.304 21.283-27.754-16.017-37.3-51.542-21.275-79.312z"
        fill="#a5a1b0"
      />
      <g fill="#fff">
        <path d="M894.78 1616.493c16.025-27.77 51.558-37.288 79.317-21.275 27.779 16.03 37.287 51.537 21.266 79.304-16.025 27.771-51.52 37.309-79.304 21.284-27.754-16.017-37.3-51.546-21.28-79.313zM864.088 953.405c0-17.183 13.65-30.833 31.342-30.833 17.183 0 30.833 13.65 30.833 30.833v297.217c0 17.187-13.65 30.837-30.833 30.837-17.692 0-31.342-13.65-31.342-30.837zM1006.522 1103.022v-1.009c0-99.07 75.82-182.979 182.475-182.979 53.075 0 88.458 12.638 120.808 35.888 6.067 4.545 12.638 13.141 12.638 25.27 0 16.68-13.65 30.834-30.838 30.834-8.083 0-14.15-3.538-19.204-7.075-22.75-16.68-47.517-27.796-85.93-27.796-65.208 0-114.75 57.112-114.75 124.846v1.012c0 72.788 48.026 126.371 120.31 126.371 33.362 0 63.687-10.616 85.424-26.796v-66.216h-69.754c-15.167 0-27.804-11.621-27.804-26.788 0-15.162 12.637-27.296 27.804-27.296h98.563c17.691 0 31.341 13.65 31.341 31.342v94.521c0 17.692-7.079 30.325-21.733 39.43-30.333 20.216-72.792 38.408-125.867 38.408-110.696 0-183.483-78.846-183.483-181.967zM1412.922 1239.501c-7.07-5.058-12.13-13.65-12.13-23.758 0-16.171 13.142-28.809 29.317-28.809 8.592 0 14.15 2.53 18.2 5.563 29.313 23.246 60.65 36.387 99.067 36.387s62.68-18.196 62.68-44.475v-1.016c0-25.271-14.155-38.917-79.863-54.084-75.317-18.196-117.775-40.433-117.775-105.642v-1.016c0-60.65 50.546-102.604 120.808-102.604 44.48 0 80.371 11.625 112.213 32.854 7.075 4.041 13.646 12.637 13.646 24.766 0 16.175-13.138 28.813-29.313 28.813-6.067 0-11.12-1.513-16.175-4.554-27.296-17.684-53.583-26.788-81.383-26.788-36.392 0-57.621 18.704-57.621 41.959v1.008c0 27.296 16.175 39.43 84.412 55.608 74.809 18.196 113.226 44.98 113.226 103.617v1.008c0 66.217-52.063 105.646-126.371 105.646-48.017 0-93.509-15.166-132.938-44.483zM1552.547 1339.51v7.083h20.167v52.75h8.166v-52.75h20.167v-7.084zM1608.364 1399.343h7.75v-35.334c0-1.416 0-3.583-.084-6.583s-.166-5.25-.166-6.75v-1.833l17.25 50.5h8l17.166-50.5c0 3.25 0 6.333-.083 9.083-.083 2.833-.167 4.917-.167 6.083v35.334h7.75v-59.834h-11.5l-17.083 50.584-17.25-50.584h-11.583z" />
      </g>
    </g>
  </svg>
  )
};

export default LogoFull;
